import { useMutation, useQueryClient } from "@tanstack/react-query"
import toast from "react-hot-toast"
// import { uploadFiles } from "services/apiUpload"
import { uploadCompletion } from "services/apiUpload"

const useSubmitFile = () => {
    const queryClient = useQueryClient()

  const{isPending,isSuccess,mutate: upload}=useMutation({
    mutationFn:(formData)=> uploadCompletion(formData),
    onSuccess:(data)=>{
        queryClient.setQueryData(["file"],data)
        console.log("data on useSubmit",data)
        localStorage.setItem("sucessUploadData",JSON.stringify(data.file))
        localStorage.setItem("count",JSON.stringify(data.order_count))
        toast.success("Upload Successful")
    },
    onError:(error)=>{
      toast.error(error?.data?.message || "An error occurred while uploading")
      console.error("Error occurred:",error)
    }
  })
  return{isPending,isSuccess,upload}
}

export default useSubmitFile